// Keeps PK · Price blocks in sync when the shopper switches variants.
// Horizon re-renders the section for the new variant and passes the HTML in its variant:update event.
document.addEventListener('variant:update', (event) => {
  const html = event.detail?.data?.html;
  if (!html) return;
  document.querySelectorAll('pk-cost[data-block-id]').forEach((el) => {
    const next = html.querySelector(`pk-cost[data-block-id="${el.dataset.blockId}"]`);
    if (next) el.innerHTML = next.innerHTML;
  });
});

// Fades [data-pk-reveal] elements in once as they enter the viewport.
// Content stays visible without JS: hiding only applies under html.pk-js.
(() => {
  const root = document.documentElement;
  if (!('IntersectionObserver' in window) || matchMedia('(prefers-reduced-motion: reduce)').matches) return;

  root.classList.add('pk-js');

  const observer = new IntersectionObserver(
    (entries) => {
      for (const entry of entries) {
        if (!entry.isIntersecting) continue;
        entry.target.classList.add('is-visible');
        observer.unobserve(entry.target);
      }
    },
    { rootMargin: '0px 0px -8% 0px', threshold: 0.12 }
  );

  const observe = (scope) => scope.querySelectorAll('[data-pk-reveal]:not(.is-visible)').forEach((el) => observer.observe(el));

  observe(document);
  // Theme editor re-renders sections in place.
  document.addEventListener('shopify:section:load', (event) => observe(event.target));
})();
